import React from 'react';
import Dict from 'dict-lib';
import {saveNotes} from './EntryActions';
import {Grid, Row, InputGroup, FormControl, Button} from 'react-bootstrap';
import './../../../../_css/lexeme.css';

export class EntryNotes extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            items: this.props.item.variants,
            note: ''
        };

        this._handleEntryNote = this._handleEntryNote.bind(this);
        this._saveEntryNotes = this._saveEntryNotes.bind(this);
    }

    componentWillMount() {
        var noteByLang = this.state.items[0].notes.notes_language_group.find((itemNote) => {
            return itemNote.language === this.props.additionalData.descrLang;
        });

        var note = typeof noteByLang !== 'undefined' && noteByLang !== null ? noteByLang.text : '';
        this.setState({note});
    }

    _handleEntryNote(item, evt) {
        var items = JSON.parse(JSON.stringify(this.state.items));
        //var index = this.state.items.indexOf(item);
        this.state.note = evt.target.value;
        this.setState({items});
    }

    _saveEntryNotes() {
        for (const item of this.state.items) {
            var itNote = item.notes.notes_language_group.find((itemNote) => {
                return itemNote.language === this.props.additionalData.descrLang;
            });

            if (typeof itNote !== 'undefined') {
                itNote.text = this.state.note;
            } else {
                item.notes.notes_language_group.push({
                    language: this.props.additionalData.descrLang,
                    text: this.state.note
                });
            }
        }

        var items = JSON.stringify(this.state.items);

        this.setState({btDisabled: true});
        saveNotes(items, this.state.note).then(result => {
            /*this.setState({btSaveState: "success", btDisabled: false}, function () {
                setTimeout(function () {
                    this.setState({btSaveState: "primary"});
                }.bind(this), 1000);
            });*/
        });
    }

    render() {
        return <Grid className="poly-notes-container" fluid>
            {this.state.items ? this.state.items.map(item =>
                <Row key={"key-poly-notes-" + item.id}>
                    <InputGroup className={"poly-notes"}>
                        <InputGroup.Addon>{item.language}</InputGroup.Addon>
                        <FormControl type="text" placeholder={Dict.t('FORM') + "..."}
                                     ref={(input) => {
                                         this.entryNote = input;
                                     }}
                                     value={this.state.note}
                                     onChange={(evt) => this._handleEntryNote(item, evt)}
                        />
                    </InputGroup>
                </Row>) : ""}
            <Row className={"row-bt-poly-notes"}><Button bsStyle={this.state.btSaveState}
                /*disabled={this.state.btDisabled}*/
                                                         onClick={() => this._saveEntryNotes()}>{Dict.t('SAVE')}</Button></Row>
        </Grid>;
    }


}
